var DeviceTypeSearchService = (function () {
    function DeviceTypeSearchService($http) {
        this.$http = $http;
    }
    DeviceTypeSearchService.prototype.get = function () {
        return this.$http
            .get('compatibilityguide/ng-settings/feature/search/devicetypesearchitems')
            .then(function (response) { return response.data || []; });
    };
    DeviceTypeSearchService.$inject = ['$http'];
    return DeviceTypeSearchService;
}());
export { DeviceTypeSearchService };
